import React, { type PropsWithChildren } from 'react';
import cn from 'classnames';
import * as styles from './styles.module.css';

type ContentLayoutProps = {
  width?: 'narrow' | 'wide';
  className?: string;
};

// Задает ширину лейаута.
// Отступы сверху и снизу задаются на сайте и в конструкторе отдельно, потому что они там разные
export function ContentLayout({
  children,
  className = '',
  width = 'wide',
}: PropsWithChildren<ContentLayoutProps>) {
  return <div className={cn([styles.content, styles[width], className])}>{children}</div>;
}
